// ======================================================================
// File: TransportDashboard.jsx
// Module: PPE → Transport
// Purpose:
//   Transport operational dashboard
//   Stable version (no render loop / no null crash)
// ======================================================================

import React, { useEffect, useState } from "react";
import transportService from "../services/transportService";

export default function TransportDashboard() {

  const [loading, setLoading] = useState(true);

  // ✅ SAFE DEFAULT STATE (IMPORTANT)
  const [summary, setSummary] = useState({
    total: 0,
    in_transit: 0,
    delivered: 0,
  });

  // ------------------------------------------------------------------
  // LOAD DASHBOARD (RUN ONCE)
  // ------------------------------------------------------------------
  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      const res = await transportService.getTransportList();
      const data = res?.data || [];

      setSummary({
        total: data.length,
        in_transit: data.filter(
          (t) => t.status_code === "IN_TRANSIT"
        ).length,
        delivered: data.filter(
          (t) => t.status_code === "DELIVERED"
        ).length,
      });

    } catch (err) {
      console.error("Dashboard load failed:", err);
    } finally {
      setLoading(false);
    }
  };

  // ------------------------------------------------------------------
  // LOADING STATE
  // ------------------------------------------------------------------
  if (loading) {
    return <div className="p-4">Loading dashboard...</div>;
  }

  // ------------------------------------------------------------------
  // RENDER
  // ------------------------------------------------------------------
  return (
    <div className="p-4">

      <h4 className="mb-4">Transport Dashboard</h4>

      <div className="row">

        {/* Total Requests */}
        <div className="col-md-4">
          <div className="card glass-card text-center">
            <div className="card-body">
              <h3>{summary.total}</h3>
              <small>Total Requests</small>
            </div>
          </div>
        </div>

        {/* In Transit */}
        <div className="col-md-4">
          <div className="card glass-card text-center">
            <div className="card-body">
              <h3>{summary.in_transit}</h3>
              <small>In Transit</small>
            </div>
          </div>
        </div>

        {/* Delivered */}
        <div className="col-md-4">
          <div className="card glass-card text-center">
            <div className="card-body">
              <h3>{summary.delivered}</h3>
              <small>Delivered</small>
            </div>
          </div>
        </div>

      </div>

    </div>
  );
}
